import React from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';

import { routes } from './routes';

import { PageLayout } from '../components/PageLayout';

import UnAuthenticated from '../pages/UnAuthenticated';

const UnAuthenticatedRoutes: React.FunctionComponent = () => {
    return (
        <Router>
            <Routes>
                <Route element={<PageLayout />}>
                    <Route path={routes.index} element={<UnAuthenticated />} />
                    <Route path="*" element={<Navigate to={routes.index} />} />
                </Route>
            </Routes>
        </Router>
    );
};

export default UnAuthenticatedRoutes;
